module.exports = __webpack_public_path__ + "img/store_is_close.c41a78d4.svg";